import React, { useState } from 'react';
import config from '../config';
import SectionReveal from '../components/SectionReveal';
import './CorporateTrial.css';

function CorporateTrial() {
  const [form, setForm] = useState({ name: '', company: '', mobile: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `🏢 Corporate Trial Request\n\nName: ${form.name}\nCompany: ${form.company}\nMobile: ${form.mobile}\n\nPlease arrange a trial for our office!`;
    window.open(config.getWhatsAppUrl(message), '_blank');
    setSubmitted(true);
  };

  return (
    <main className="corporate-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero__content">
            <span className="section-badge">For Businesses</span>
            <h1>Request a Corporate Trial</h1>
            <p>Boost your team's wellness with fresh, premium fruit cups delivered daily to your office.</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="corporate-grid">
            <SectionReveal animation="slideInLeft">
              <div className="corporate-benefits">
                <h2>Why Corporate Wellness?</h2>
                <p>Companies investing in employee health see measurable improvements across the board.</p>

                <div className="corporate-benefits__list">
                  {[
                    { icon: '📈', title: 'Boost Productivity', desc: 'Healthy employees are up to 20% more productive.' },
                    { icon: '🩺', title: 'Fewer Sick Days', desc: 'Good nutrition reduces sick leave significantly.' },
                    { icon: '😊', title: 'Happier Teams', desc: 'A healthy perk that employees actually love.' },
                    { icon: '💰', title: 'Bulk Discounts', desc: 'Special pricing for 20+ cups daily.' },
                  ].map((item, idx) => (
                    <div key={idx} className="corporate-benefit-item">
                      <span>{item.icon}</span>
                      <div>
                        <h4>{item.title}</h4>
                        <p>{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </SectionReveal>

            <SectionReveal animation="slideInRight" delay={0.2}>
              <div className="corporate-form-card">
                {!submitted ? (
                  <>
                    <h3>Get Your Free Trial</h3>
                    <p>Fill in the details below and we'll get in touch.</p>
                    <form onSubmit={handleSubmit} className="corporate-form">
                      <div className="corporate-form__group">
                        <label htmlFor="name">Your Name *</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          placeholder="John Doe"
                          required
                        />
                      </div>
                      <div className="corporate-form__group">
                        <label htmlFor="company">Company Name *</label>
                        <input
                          type="text"
                          id="company"
                          name="company"
                          value={form.company}
                          onChange={handleChange}
                          placeholder="Your Company"
                          required
                        />
                      </div>
                      <div className="corporate-form__group">
                        <label htmlFor="mobile">Mobile Number *</label>
                        <input
                          type="tel"
                          id="mobile"
                          name="mobile"
                          value={form.mobile}
                          onChange={handleChange}
                          placeholder="+91 98765 43210"
                          required
                        />
                      </div>
                      <button type="submit" className="btn btn-primary corporate-form__submit">
                        Submit & Connect on WhatsApp
                      </button>
                    </form>
                  </>
                ) : (
                  <div className="corporate-form__success">
                    <span className="corporate-form__success-icon">🎉</span>
                    <h3>Request Sent!</h3>
                    <p>We've received your trial request. Our team will contact you shortly.</p>
                    <button className="btn btn-secondary" onClick={() => setSubmitted(false)}>
                      Submit Another Request
                    </button>
                  </div>
                )}
              </div>
            </SectionReveal>
          </div>
        </div>
      </section>
    </main>
  );
}

export default CorporateTrial;
